import { CommentStatusEnum } from '../../constants';

const defaultTextEditorValue =
  '{"blocks":[{"key":"75mui","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export default class ResponseModel {
  id: string;
  commentId: string;
  description: string;
  status: string;
  touched: false;
  attachments: any[];

  constructor(data: any = {}) {
    this.id = data.id || undefined;
    this.commentId = data.commentId || '';
    this.description = data.description || defaultTextEditorValue;
    this.status = data.status || CommentStatusEnum.DRAFT;
    this.touched = typeof data.touched === 'boolean' ? data.touched : false;
    this.attachments = data.attachments || [];
  }
}
